const MarkerIcons = {
    car_top : require('./car_top.png'),
    event_black : require('./event_black.png'),
    corporate : require('./corporate_branch.png')
}

export default MarkerIcons